import API from "@/axios/api";

export const DUPLICATE_MASTER_SNACKBAR = {
  color: 'error',
  text: 'Вы пытаетесь добавить на данный объект модуль ПО, мастер-лицензия на который на объекте уже есть. ' +
    'Так делать нельзя. Сделайте новый объект и добавляйте мастер-лицензию на него.',
  timeout: 20000,
  closeText: 'ОК',
  large: true,
}

export async function objectHasMaster(objectId, moduleId) {
  const response = await API.get(`objects/${objectId}/masters`)
  return response.data.masters.some(master => master.projectId === moduleId && !master.isDeleted)
}
